import { FileText, Folder, MessageSquare, Plus } from "lucide-react";
import { useFranklinContext } from "../../context/franklin-context";

const NAV_ITEMS = [
  { icon: FileText, label: "Knowledge Base", tab: "knowledge" as const },
  { icon: Folder, label: "My Cases", tab: "cases" as const },
  { icon: Plus, label: "Submit a New Case", tab: "ai" as const },
  { icon: MessageSquare, label: "Speak with Support", tab: "ai" as const },
];

export function SidebarFooter() {
  const { setActiveTab } = useFranklinContext();

  return (
    <div
      className="border-t"
      style={{
        borderColor: "rgba(0, 0, 0, 0.06)",
        backgroundColor: "var(--franklin-surface)",
        paddingBottom: "20px",
      }}
    >
      {/* Navigation Links */}
      <div className="space-y-3 px-6 pt-6 pb-2">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <button
              className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 font-normal text-sm transition-all hover:bg-gray-50"
              key={item.label}
              onClick={() => setActiveTab(item.tab)}
              style={{
                color: "#6B7280",
              }}
              type="button"
            >
              <Icon className="h-4 w-4" strokeWidth={1.5} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>

      {/* Powered by Franklin */}
      <div
        className="mx-6 mt-6 border-t pt-4 pb-16"
        style={{ borderColor: "rgba(0, 0, 0, 0.06)" }}
      >
        <p
          className="text-center font-normal text-xs"
          style={{ color: "#9CA3AF" }}
        >
          Powered by{" "}
          <span className="font-medium" style={{ color: "#6B7280" }}>
            Franklin
          </span>
        </p>
      </div>
    </div>
  );
}
